var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLiLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.205 0H0.695652C0.298137 0 0 0.3 0 0.7V15.4C0 15.7 0.298137 16 0.695652 16H15.3043C15.7019 16 16 15.7 16 15.3V0.7C15.9006 0.3 15.6025 0 15.205 0ZM4.67081 13.6H2.38509V6H4.77019V13.6H4.67081ZM3.57764 5C2.78261 5 2.18634 4.3 2.18634 3.6C2.18634 2.8 2.78261 2.2 3.57764 2.2C4.37267 2.2 4.96894 2.8 4.96894 3.6C4.86957 4.3 4.27329 5 3.57764 5ZM13.5155 13.6H11.1304V9.9C11.1304 9 11.1304 7.9 9.93789 7.9C8.74534 7.9 8.54658 8.9 8.54658 9.9V13.7H6.16149V6H8.4472V7C8.74534 6.4 9.54037 5.8 10.6335 5.8C13.0186 5.8 13.4161 7.4 13.4161 9.4V13.6H13.5155Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiLogo);
export default __webpack_public_path__ + "static/media/LI_logo.6d1bac38.svg";
export { ForwardRef as ReactComponent };